import {AppsyncService} from './AppsyncService'
import gql from "graphql-tag";

import {
    getPayload,
    getPayloadUrlOnly,
    getRequest,
    getRequestDetails,
    listFlowsDynamicSearch,
    listRequestsDynamicSearch,
    listFlowFieldSearch
} from "../../graphql/flow-overview/queries";
import {oktaAuth} from "../config/OktaConfig";
import { getMinimumQueryDate, isBeforeGoLive } from '../config/GoLiveConfig';

export class StructuredLogsService {

    appsyncService : AppsyncService;

    constructor() {
        this.appsyncService = new AppsyncService(process.env.REACT_APP_APPSYNC_FLOW_OVERVIEW_ENDPOINT!, oktaAuth)
    }

    async getRequest(traceId: string): Promise<any> {
        return this.appsyncService.appSyncClient.query({
                query: gql(getRequest), fetchPolicy: 'network-only', variables: {
                    traceId: traceId
                }
            }
        );
    }

    async getPayload(region: string, bucket: string, key: string, version: string, urlOnly: boolean): Promise<any> {
        return this.appsyncService.appSyncClient.query({
                query: gql(urlOnly ? getPayloadUrlOnly : getPayload),
                fetchPolicy: 'network-only',
                variables: {
                    region: region,
                    bucket: bucket,
                    key: key,
                    version: version
                }
            }
        );
    }

    async getRequestDetails(traceId: string, logType: string): Promise<any> {
        return this.appsyncService.appSyncClient.query({
                query: gql(getRequestDetails), fetchPolicy: 'network-only', variables: {
                    traceId: traceId,
                    logType: logType
                }
            }
        );
    }

    async listRequestForFlow(flowId: string): Promise<any> {
        return this.appsyncService.appSyncClient.query({
                query: gql(listRequestsDynamicSearch), fetchPolicy: 'network-only', variables: {
                    flowId: flowId,
                }
            }
        );
    }

    async listFlows(
        typeList: string[],
        statusList: string[],
        startDate: Date,
        endDate: Date,
        businessReference: string,
        flowId: string,
        detailList: string[],
        shippingPointList: string[],
        inventoryLocationList: string[],
        triggerList: string[],
        permissions: any
    ): Promise<any> {
        console.log("listFlows called with triggerList:", triggerList); // Debug logging
        const minDate = getMinimumQueryDate();
        let fromTimestamp: number;
        let toTimestamp: number | null = null;
        const canViewPostGoLiveLogging = permissions.canViewPostGoLiveLogging;
        if (!startDate || (!canViewPostGoLiveLogging && isBeforeGoLive(startDate))) {
            fromTimestamp = minDate.getTime();
        } else {
            fromTimestamp = startDate.getTime();
        }

        if (endDate) {
            toTimestamp = (!canViewPostGoLiveLogging && isBeforeGoLive(endDate)) ? minDate.getTime() : endDate.getTime();
        }
        const variables = {
            typeList: typeList && typeList.length > 0 ? typeList : null,
            statusList: statusList && statusList.length > 0 ? statusList : null,
            fromTimestamp: fromTimestamp,
            toTimestamp: toTimestamp,
            businessReference: businessReference || null,
            flowId: flowId || null,
            detailList: detailList && detailList.length > 0 ? detailList : null,
            shippingPointList: shippingPointList && shippingPointList.length > 0 ? shippingPointList : null,
            inventoryLocationList: inventoryLocationList && inventoryLocationList.length > 0 ? inventoryLocationList : null,
            triggerList: triggerList && triggerList.length > 0 ? triggerList : null
        };

        console.log("GraphQL variables:", variables); // Debug logging

        return this.appsyncService.appSyncClient.query({
            query: gql(listFlowsDynamicSearch),
            fetchPolicy: 'network-only',
            variables: variables
        });
    }

    async listFieldOptions(fieldName: string): Promise<any> {
        return this.appsyncService.appSyncClient.query({
            query: gql(listFlowFieldSearch), fetchPolicy: 'network-only', variables: {
                fieldName: fieldName
            }
        }
    );
    }

}